import flag from "../../assets/flags/flag-table.png";
import badgesImg from "../../assets/badges/uae-flag-day-magnetic-enamel-badge.png";
import flagpole from "../../assets/flagpoles/outdoor-white-powder-coated-aluminum-flagpole.jpg";
import apparel from "../../assets/apparels/white-short-sleeve-corporate-uniform.jpg";
import lanyards from "../../assets/lanyards/premium-leather-lanyard-id-badge-closeup.png";
import banner from "../../assets/banners/custom-printed-banner-display.svg";
import sticker from "../../assets/stickers/on-building-facade-sticker.png";

/**
 * fit: "contain" = product cut-out (whole product on a soft background)
 *      "cover"   = real photo (fills the image area)
 */
export const servicesKeys = {
  hero: {
    title: "nav:services",
    subtitle: "home:sections:whyTitle",
  },
  cards: [
    { slug: "custom-flags", title: "services:flags", desc: "services:cards:flagsDesc", img: flag, fit: "contain" },
    { slug: "flagpoles", title: "services:flagpoles", desc: "services:cards:flagpolesDesc", img: flagpole, fit: "contain" },
    { slug: "banners", title: "services:banners", desc: "services:cards:bannersDesc", img: banner, fit: "cover" },
    { slug: "badges", title: "services:badges", desc: "services:cards:badgesDesc", img: badgesImg, fit: "contain" },
    { slug: "sticker", title: "services:sticker", desc: "services:cards:stickerDesc", img: sticker, fit: "cover" },
    { slug: "apparel", title: "services:apparel", desc: "services:cards:apparelDesc", img: apparel, fit: "cover" },
    { slug: "lanyards", title: "services:lanyards", desc: "services:cards:lanyardsDesc", img: lanyards, fit: "contain" },
  ],
} as const;

export const serviceCardAlts: Record<string, string> = {
  "custom-flags": "UAE national table flag on a gold metal stand",
  flagpoles: "White powder-coated aluminium outdoor flagpole flying the UAE flag",
  banners: "Custom printed fence banners displayed along an outdoor event venue",
  badges: "UAE Flag Day magnetic enamel badge and lapel pin",
  sticker: "Large printed sticker applied to a building facade",
  apparel:
    "White short-sleeve corporate uniform shirt paired with navy trousers for professional staff wear",
  lanyards: "Premium leather lanyard with ID badge holder, close-up",
};

export type ServiceCardKey = (typeof servicesKeys.cards)[number];
